import React from 'react';
import { ChevronRight, Clock, Users, Heart, Award } from 'lucide-react';

export default function Hero() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const features = [
    {
      icon: Clock,  
      title: "Termine",
      description: "Termine nach telefonischer Vereinbarung"
    },
    {
      icon: Users,
      title: "Erfahrenes Team",
      description: "Über 25 Jahre Erfahrung"
    },
    {
      icon: Heart,
      title: "Persönliche Betreuung",
      description: "ausreichend Zeit für jeden Patienten"
    },
    {
      icon: Award,
      title: "Moderne Ausstattung",
      description: "Neueste Diagnostik"
    }
  ];

  return (
    <section id="home" className="hero">
      <div className="hero-bg-decoration hero-bg-decoration-1"></div>
      <div className="hero-bg-decoration hero-bg-decoration-2"></div>

      <div className="hero-container">
        <div className="hero-grid">
          <div className="hero-content">
            <h2 className="hero-title">
              Innere Medizin<br />
              <span className="hero-title-gradient">
                und Rheumatologie
              </span>
            </h2>
            <p className="hero-description">
              Moderne Medizin mit persönlicher Betreuung. Wir nehmen uns Zeit für Sie und bieten 
              Diagnostik und Behandlung auf höchstem Niveau.
            </p>
            
            <div className="hero-buttons">
              <button
                onClick={() => scrollToSection('kontakt')} className="btn-primary">Termin vereinbaren
                <ChevronRight size={20} /></button>
              <button onClick={() => scrollToSection('leistungen')} className="btn-secondary">Unsere Leistungen</button>
            </div>
          </div>
          <div className="hero-features">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div key={index} className="feature-card">
                  <div className="feature-icon">
                    <IconComponent color="white" size={24} />
                  </div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}